/* @generated */

// src/assets/ui-icon/line/stamp.tsx
import * as React from "react";
var StampLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M19 17.5H5V19h14v-1.5Zm0-1.5H5v-1.25a3.254 3.254 0 0 1 3.25-3.25h1.245a2.646 2.646 0 0 0-.775-1.719l-.22-.22V8.25C8.5 6.337 9.939 5 12 5s3.5 1.337 3.5 3.25v1.31l-.22.22a2.685 2.685 0 0 0-.775 1.72h1.245A3.254 3.254 0 0 1 19 14.75V16ZM6.518 14.5h10.964A1.75 1.75 0 0 0 15.75 13H13v-1.336a4.133 4.133 0 0 1 1-2.707V8.25c0-1.063-.785-1.75-2-1.75-1.215 0-2 .687-2 1.75v.707a4.134 4.134 0 0 1 1 2.705V13H8.25a1.75 1.75 0 0 0-1.732 1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  StampLine
};
